
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import '@fortawesome/fontawesome-free/css/all.css';

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify, {
  rtl: true
});

const opts = {
  // theme: {
  //   dark: true,
  // },
  icons: {
    iconfont: 'mdiSvg', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    values: {
      fa: {
        component: 'font-awesome-icon', 
      },
    },
  },
  theme:{
    themes:{
      light:{
        primary: "#1F2937",
        secondary: "#3366FF",
        lightSecondary: "#6d7de5",
        brandDark: "#02081A",
        brandBlue: "#1232DC",
      },
      dark:{
        primary: "#FAFAFA", 
        secondary: "#3366FF", 
        lightSecondary: "#6d7de5", 
        "blue-grey": "#1c1c1e", 
        sidebarBackground: "#121212", 
        grey: "#B0BEC5", 
        black: {
          base: "#121212", 
          lighten2: "#1e1e1e",
          lighten3: "#2a2a2a",
        },
        cardBackground: "#1F1F1F", // Muted dark for content areas
      }
    },
    options: {
      customProperties: true
    }
  }
};

export default new Vuetify(opts);
